app.controller("ApartmentSearchPageController",
	["$rootScope", "$scope", "ApartmentSearchService", "ApartmentSearchModel", "$timeout", "$interval", "$location", "BrowserStorageService", "AreaNaviService", function($rootScope, $scope, ApartmentSearchService, ApartmentSearchModel, $timeout, $interval, $location, BrowserStorageService, AreaNaviService) {

		var loadPagesSaveKey = 'LoadMoreCount';
		var loadPagesOnInit = parseInt(localStorage.getItem(loadPagesSaveKey)) || 1;
		var historyTimeoutActive = false;

		$scope.searchParameterChanged = false;
		$scope.searchAddressChanged = false;
		$scope.searchID = "mainSearch";
		$scope.searchResults = ApartmentSearchModel.results;
		$scope.autoSearching = false;

		$scope.LoadMore = function(callback) {
			// When user initializes "load more" it comes without callback.
			// In this case we create a callback which increases count number for user's click
			if (!callback) {
				callback = function() {
					loadPagesOnInit += 1;
					localStorage.setItem(loadPagesSaveKey, loadPagesOnInit);
				};
			}

			ApartmentSearchModel.query.SetSkip(ApartmentSearchModel.query.GetSkip() + ApartmentSearchModel.query.GetResultLimit());
			ApartmentSearchService.RunQuery(ApartmentSearchModel.query, $scope.searchID, true, callback);
		};

		$scope.$watch('searchResults[searchID].loading', function(newVal) {
			if(newVal && typeof($scope.autoSearchTimeout) != 'undefined' && !$scope.autoSearching) {
				// Haku tehty muualta (todennäköisesti hakunappulasta), perutaan automaattinen haku
				$timeout.cancel($scope.autoSearchTimeout);
			}
		});

		$scope.OnSearchParameterChanged = function(newValue, oldValue) {
			// Commented out because search change was rewritten and this started to cause errors
			// which were noticed later. Everything works, but this could be fixed at some point (:
			//var emptyConstraintChange = LookForEmptyConstraintChange(newValue, oldValue);
			if(angular.equals(newValue, oldValue)/* || emptyConstraintChange*/) {
				return;
			}

			// This is mostly when in /myytavat_asunnot/Espoo landing page we change params.
			if (!$rootScope.useWindowLocation && !ApartmentSearchService.redirectSearch && $location.$$path !== '/haku') {
				$location.path('/haku');
			}

			if(typeof($scope.autoSearchTimeout) != 'undefined') {
				$timeout.cancel($scope.autoSearchTimeout);
			}
			$scope.searchParameterChanged = true;
			if (JSON.stringify(angular.copy(newValue.address)) != JSON.stringify(angular.copy(oldValue.address))) {
				AreaNaviService.setVisible(false);
				$scope.searchAddressChanged = true;
			}
			ApartmentSearchModel.query.SetVideo(false);
			$scope.autoSearchTimeout = $timeout(function () {
				$scope.autoSearching = true;
				ApartmentSearchModel.query.SetSkip(0);
				BrowserStorageService.LocalStorage.SetItem("ApartmentSearchQuery", ApartmentSearchModel.query.GetAsStorageBlob());
				ApartmentSearchService.RunQuery(ApartmentSearchModel.query, $scope.searchID, false, function() {
					//$("body").animate({ scrollTop: 0 }, "slow");
					$timeout.cancel($scope.autoSearchTimeout);
					$scope.autoSearching = false;
				});

				if (historyTimeoutActive) {
					$timeout.cancel(historyTimeoutActive);
				}

				historyTimeoutActive = $timeout(function() {
					ApartmentSearchService.SaveSearchHistory(ApartmentSearchModel.query.GetAsStorageBlob());
				}, 1000);

			}, 1200);
		};

		ApartmentSearchService.AddNotificationListener('ApartmentSearchBarReady', function(data) {
			// If user has used "load more" load as many pages as user has loaded
			data.query.SetResultLimit(data.query.GetResultLimit() * loadPagesOnInit);

			ApartmentSearchService.RunQuery(data.query, data.searchID, false);

			// Vahtaa standard, extended parametrejä ja sorttausta
			$scope.$watch(function() { return ApartmentSearchModel.query.GetExtendedConstraints(); }, function(newValue, oldValue) {
				$scope.OnSearchParameterChanged(newValue, oldValue);
			}, true);

			$scope.$watch(function() { return ApartmentSearchModel.query.GetStandardConstraints(); }, function(newValue, oldValue) {
				$scope.OnSearchParameterChanged(newValue, oldValue);
			}, true);

			$scope.$watch(function() { return ApartmentSearchModel.query.GetSorting(); }, function(newValue, oldValue) {
				$scope.OnSearchParameterChanged(newValue, oldValue);
			});

			$scope.$watch(function() { return ApartmentSearchModel.query.GetRental(); }, function(newValue, oldValue) {
				$scope.OnSearchParameterChanged(newValue, oldValue);
			});

		});

		function LookForEmptyConstraintChange(newValue, oldValue) {
			var constraintFound = false;
			// Check if constraint is added
			for(var i in newValue) {
				constraintFound = false;
				for(var j in oldValue) {
					if(newValue[i].internalId == oldValue[j].internalId) {
						constraintFound = true;
						break;
					}
				}
				if(!constraintFound) {
					return true;
				}
			}
			// Check if removed constraint has no selected values
			for(var k in oldValue) {
				constraintFound = false;
				var constraintId = oldValue[k].internalId;
				for(var l in newValue) {
					if(oldValue[k].internalId == newValue[l].internalId) {
						constraintFound = true;
						break;
					}
				}
				if(!constraintFound) {
					if(angular.equals(oldValue[k], ApartmentSearchService.GetAvailableConstraint(constraintId))) {
						return true;
					} else {
						return false;
					}
				}
			}
		}
	}]
);